<script lang="ts">
    import type { Color } from "@/types/UITypes";
    import { sineIn } from "svelte/easing";

    export let progress: number;
    export let barColor: Color | null = null;
    export let animation = true;

    const parseProgress = (progress: number): number => {
        if (progress < 0) return 0;

        if (progress > 100) return 100;

        return progress;
    };

    const widthTransition = (_: HTMLElement, animation: boolean) => ({
        delay: 0,
        duration: animation ? 300 : 0,
        easing: sineIn,
        css: (t: number) => `width: ${t};`,
    });

    $: parsedProgress = parseProgress(progress);
</script>

<div class="gw-progress-bar">
    <div class="gw-progress-bar__inner">
        {#if parsedProgress}
            <div
                class="gw-progress-bar__fill"
                style:--gw-progress-bar-width="{parsedProgress}%"
                style:--gw-progress-bar-color="var({barColor})"
                in:widthTransition={animation}
            />
            <progress
                class="gw-progress-bar__progress"
                value={parsedProgress}
                max="100"
                aria-valuemin="0"
                aria-valuenow={parsedProgress}
                aria-valuemax="100"
            />
        {/if}
    </div>
    <slot />
</div>

<style lang="postcss">
    .gw-progress-bar {
        width: 100%;
        &__inner {
            height: var(--gw-height-100);
            overflow: hidden;
            background-color: var(--gw-bg-fill-disabled);
            border-radius: var(--gw-border-radius-full);
        }

        &__fill {
            width: var(--gw-progress-bar-width);
            height: 100%;
            background-color: var(
                --gw-progress-bar-color,
                var(--gw-theme__main-color)
            );
        }

        &__progress {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: 0;
            overflow: hidden;
            clip: rect(0 0 0 0);
            clip-path: inset(50%);
            white-space: nowrap;
            border: 0;
        }
    }
</style>
